export const API_ENDPOINTS = {
  CHAT_STREAM: `/api/v1/chat/stream`,
  CHAT_HISTORY: `/api/v1/chat/history`,
  EXPORT_SUMMARY: `/api/v1/chat/export-summary`
}; 